import {
  formatPractitionerAddress,
  formatPractitionerName,
  formatPractitionerPhone,
  formatRoleSpecialty,
  type TemplatePractitioner,
} from './templateUtils';

export interface TemplatePractitionerBlockProps {
  practitioner?: TemplatePractitioner;
}

export const TemplatePractitionerBlock = ({
  practitioner,
}: TemplatePractitionerBlockProps) => (
  <div className="flex flex-col gap-1.5">
    <p className="text-[10px] leading-tight font-bold tracking-[0.35px] text-zinc-500 uppercase">
      Practitioner
    </p>
    <p className="text-[11px] leading-tight text-zinc-950">
      <span className="font-bold">Name:</span>{' '}
      {formatPractitionerName(practitioner)}
    </p>
    <p className="text-[11px] leading-tight text-zinc-950">
      <span className="font-bold">Phone:</span>{' '}
      {formatPractitionerPhone(practitioner)}
    </p>
    <p className="text-[11px] leading-tight text-zinc-950">
      <span className="font-bold">Address:</span>{' '}
      {formatPractitionerAddress(practitioner)}
    </p>
    <p className="text-[11px] leading-tight text-zinc-950">
      <span className="font-bold">Role Specialty:</span>{' '}
      {formatRoleSpecialty(practitioner)}
    </p>
  </div>
);
